import ApiService from "@/core/services/api.service";
// action types
export const PAGINATION_CAMPAIGN = "paginationCampaign";
export const GET_CAMPAIGN = "getCampaign";
export const FIND_CAMPAIGN = "findCampaign";
export const CREATE_CAMPAIGN = "createCampaign";
export const UPDATE_CAMPAIGN = "updateCampaign";
export const UPDATE_CAMPAIGN_ISACTIVE = "updateCampaignIsActive";
export const DELETE_CAMPAIGN = "deleteCampaign";
export const DASHBOARD_CHART_CAMPAIGN = "dashboardChartCampaign";
export const DASHBOARD_CUSTOMER_LINE_CHART_CAMPAIGN = "dashboardCustomerLineCampaign";
export const DASHBOARD_REG_PER_DAY_LINE_CHART_CAMPAIGN = 'dashboardRegPerDayLineCampaign'
// mutation types
export const SET_PAGINATION = "setPagination";
export const SET_IS_CLEAR_PAGINATION = "setIsClearPagination";
export const CLEAR_PAGINATION = "clearPagination";

export default {
  state: {
    path: "campaign",
    isClearPagination: true,
    pagination: {
      page: 1,
      perPage: 25,
      orderBy: "id",
      isDesc: true,
      sortDirection: "asc",
      filter: ""
    }
  },
  getters: {},
  actions: {
    [PAGINATION_CAMPAIGN](context, payload) {
      ApiService.setHeader();
      return ApiService.getParams(`${context.state.path}/pagination`, {
        params: payload.params
      });
    },
    [GET_CAMPAIGN](context) {
      ApiService.setHeader();
      return ApiService.getParams(`${context.state.path}`);
    },
    [FIND_CAMPAIGN](context, payload) {
      ApiService.setHeader();
      return ApiService.getParams(`${context.state.path}/${payload.id}`, null);
    },
    [CREATE_CAMPAIGN](context, payload) {
      ApiService.setHeader();
      return ApiService.post(`${context.state.path}`, payload.data);
    },
    [UPDATE_CAMPAIGN](context, payload) {
      ApiService.setHeader();
      return ApiService.put(
        `${context.state.path}/${payload.id}`,
        payload.data
      );
    },
    [UPDATE_CAMPAIGN_ISACTIVE](context, payload) {
      ApiService.setHeader();
      return ApiService.put(
        `${context.state.path}_isActive/${payload.id}`,
        payload.data
      );
    },
    [DELETE_CAMPAIGN](context, payload) {
      ApiService.setHeader();
      return ApiService.delete(`${context.state.path}/${payload.id}`);
    },
    [DASHBOARD_CHART_CAMPAIGN](context, payload) {
      ApiService.setHeader();
      return ApiService.getParams(
        `${context.state.path}/dashboard/${payload.id}`,
        { params: payload.params }
      );
    },
    [DASHBOARD_CUSTOMER_LINE_CHART_CAMPAIGN](context, payload) {
      ApiService.setHeader();
      return ApiService.getParams(
        `${context.state.path}/dashboard_customer_line_chart/${payload.id}`,
        {
          params: payload.params
        }
      );
    },
    [DASHBOARD_REG_PER_DAY_LINE_CHART_CAMPAIGN](context, payload) {
      ApiService.setHeader();
      return ApiService.getParams(
        `${context.state.path}/dashboard_reg_per_day_line_chart/${payload.id}`,
        {
          params: payload.params
        }
      );
    }
  },
  mutations: {
    [SET_PAGINATION](state, payload) {
      state.pagination = payload.pagination;
    },
    [SET_IS_CLEAR_PAGINATION](state, payload) {
      state.isClearPagination = payload.isClearPagination;
    },
    [CLEAR_PAGINATION](state) {
      state.pagination = {
        page: 1,
        perPage: 25,
        orderBy: "id",
        isDesc: true,
        sortDirection: "asc",
        filter: ""
      };
    }
  }
};
